import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { uid } from 'react-uid';

import ParagraphCard from '../ParagraphCard';

import Heading from '../../fields/Heading';

const ParagraphCardList = props => {
    const classes = classNames('card-list', {
        [`${props.classes}`]: props.classes,
    });
    return (
        <section className="card-list--container">
            {props.title && (
                <Heading level={2} classes="card-list__title">
                    {props.title}
                </Heading>
            )}
            <ul className={classes}>
                {props.r.cards.map((item, index) => {
                    return (
                        <li className="card-list__item" key={uid(item, index)}>
                            <ParagraphCard {...item} />
                        </li>
                    );
                })}
            </ul>
        </section>
    );
};

ParagraphCardList.propTypes = {
    /** Optional Title */
    title: PropTypes.string,
    /** Modifying classes */
    classes: PropTypes.string,
    /** Entity References */
    r: PropTypes.shape({
        cards: PropTypes.array,
    }),
};

export default ParagraphCardList;
